export const BORDER_WEIGHT_NAMES = ['thin', 'regular'] as const;

export const BASE_BORDER_RADIUS = 8;
